import React from "react";
import ExclamationMarkTriangleIcon from "calcite-ui-icons-react/ExclamationMarkTriangleIcon";

const InvalidAssignment = () => {
  return (
    <div style={{ display: "flex", gap: "3px" }}>
      <ExclamationMarkTriangleIcon size="16" color="orange" style={{ alignSelf: "center" }} />
      {/* TODO Remove hard-coded string for next release (https://github.com/EsriPS/indoors-web/issues/6169) */}
      <span>Invalid assignment</span>
    </div>
  )
}
export default InvalidAssignment;